import { cn } from '@/utils/cn';
import Skeleton from './Skeleton';

interface SkeletonTextProps {
  /** Number of lines to render. Defaults to 1. */
  lines?: 1 | 2 | 3;
  className?: string;
}

/**
 * SkeletonText — one to three lines of shimmer text placeholders.
 * The last line is shorter to mimic a natural paragraph ending.
 */
function SkeletonText({ lines = 1, className }: SkeletonTextProps) {
  const widths: string[] = [];
  if (lines >= 1) widths.push('w-full');
  if (lines >= 2) widths.push('w-5/6');
  if (lines >= 3) widths.push('w-2/3');

  return (
    <div className={cn('space-y-2', className)} aria-hidden="true">
      {widths.map((w, i) => (
        <Skeleton key={i} className={cn('h-3 rounded', w)} />
      ))}
    </div>
  );
}

export default SkeletonText;
